export const translations = {
  de: {
    nav: {
      leadership: "Leadership",
      teams: "Team",
      organisation: "Organisation",
      strategie: "Strategie",
      about: "Über mich",
      contact: "Kontakt",
      cta: "Kontakt aufnehmen",
      menu: "Menü",
      close: "Schließen",
    },
    consent: {
      text: "Es würde mir sehr helfen, wenn Sie den Analyse-Cookies zustimmen. So kann ich die Nutzung besser verstehen und verbessern. Danke.",
      privacy: "Datenschutzerklärung",
      settings: "Einstellungen",
      accept: "Zustimmen",
      close: "Schließen",
      settingsTitle: "Cookie-Einstellungen",
      necessary: "Technisch notwendig",
      alwaysActive: "Immer aktiv",
      analytics: "Analyse",
      save: "Auswahl speichern",
    },
    hero: {
      eyebrow: "Coaching · Training · Organisationsentwicklung",
      line1: "Leadership &",
      line2: "Team Performance",
      accent: "Wirksam durch psychologische Tiefe.",
      sub: "Wo Führung, Zusammenarbeit und Veränderung wirklich herausfordernd werden, liegen die entscheidenden Themen oft nicht auf der Oberfläche.",
      ctaPrimary: "Kontakt aufnehmen",
      ctaSecondary: "Mehr erfahren",
      scroll: "Scrollen",
    },
    human: {
      label: "Ausgangspunkt",
      line1: "Organisationen verändern sich.",
      line2: "Menschen bleiben Menschen.",
      body: "Mit Überzeugungen und Emotionen. Mit Stärken und Widersprüchen. Perfekt unperfekt.",
      question: "Was wäre möglich, wenn Sie diese Energie für Ihre Vision nutzen könnten?",
      imgAlt: "David Frank — Porträt",
    },
    manifesto: {
      label: "Was meine Arbeit prägt",
      chapters: [
        {
          num: "01",
          title: "Haltung entscheidet",
          text: "Haltung, Verhalten und Kultur machen den entscheidenden Unterschied, wenn es um Performance geht. Mein Fokus liegt deswegen auf der Veränderung von Mustern und Dynamiken in und zwischen Menschen.",
        },
        {
          num: "02",
          title: "Welten vereinen",
          text: "Ich bringe Perspektiven aus Leadership-Entwicklung, Lean Management, Organisationsentwicklung, Change-Management, Gruppendynamik sowie Psychologie zusammen – und kombiniere sie bewusst zu wirksamen Begleitungsprozessen.",
        },
        {
          num: "03",
          title: "Entwicklung spürbar machen",
          text: "In Trainings, Workshops und Projekten fördere ich das bewusste innere Erleben neuer Situationen und schaffe Spiegel zur Selbstreflexion. Dadurch entstehen neue Referenzerfahrungen, die nachhaltig wirken – in bestimmten Settings wird Veränderung bereits im gegenwärtigen Moment spürbar.",
        },
      ],
    },
    focus: {
      label: "Arbeitsfelder",
      title: "Woran wir gemeinsam arbeiten können",
      items: [
        {
          to: "/leadership",
          img: "/images/svc-leadership.jpg",
          alt: "Seilschaft von Bergsteigern in weitläufiger, verschneiter Berglandschaft",
          title: "Leadership-Entwicklung",
          short: "Leadership",
          sub: "Menschliche Dynamiken verstehen lernen",
        },
        {
          to: "/team",
          img: "/images/svc-team.jpg",
          alt: "Zwei Athleten stehen gemeinsam in einem schmalen Boot auf ruhigem Wasser — Schwarz-Weiß-Aufnahme",
          title: "Team-Entwicklung",
          short: "Team",
          sub: "Performance durch psychologische Sicherheit",
        },
        {
          to: "/strategie",
          img: "/images/svc-strategy.jpg",
          alt: "Brechende Welle in tiefem Blau",
          title: "Dynamische Strategie",
          short: "Strategie",
          sub: "Auf instabilen Zeiten surfen lernen",
        },
        {
          to: "/organisation",
          img: "/images/svc-organisation.jpg",
          alt: "Menschenmenge auf einem Zebrastreifen aus der Vogelperspektive — Schwarz-Weiß-Aufnahme",
          title: "Organisation & Kultur",
          short: "Organisation",
          sub: "Menschen bei Veränderungen mitnehmen",
        },
      ],
      more: "Vertiefen",
    },
    statement: {
      line1: "„Psychologische Tiefe",
      line2: "trifft Business Performance.“",
    },
    cases: {
      label: "Beispielfälle",
      title: "Vielleicht kommt Ihnen das bekannt vor.",
      cta: "Zum Arbeitsfeld",
      items: [
        {
          title: "Manager UND Leader sein",
          text: "Fachliche Expertise hat mich hierhergebracht. Doch wie führe ich, wenn Erwartungen auseinandergehen, Spannungen entstehen oder Menschen einfach nicht mitziehen?",
          field: 0,
        },
        {
          title: "Unvorhersagbares übernimmt die Strategie",
          text: "Wir haben zwar einen Plan, aber der hält nur bis zum nächsten Newsbeitrag. In der heutigen Zeit ist es schwer, sich noch wo anhalten zu können. Was wenn das Unvorhersagbare Teil unserer Strategie wird?",
          field: 2,
        },
        {
          title: "Kein Drive mehr im Team",
          text: "Eigentlich läuft alles. Doch irgendwie fehlt die Energie. Trotzdem sagt niemand, was wirklich los ist. Wie kommen wir wieder ins Gespräch?",
          field: 1,
        },
        {
          title: "Veränderung – aber keiner macht mit",
          text: "Lean. Agil. KI. Eine Veränderung jagt die nächste. Strukturen sind schnell angepasst – aber wie schaffen wir es, dass Menschen wirklich mitgehen?",
          field: 3,
        },
      ],
    },
    formats: {
      label: "Formate",
      title: "Drei Wege, Entwicklung zu gestalten",
      items: [
        {
          title: "Coaching",
          text: "Individuelle Reflexion, Perspektive und Entwicklung – im geschützten Rahmen.",
        },
        {
          title: "Training",
          text: "Menschliche und zwischenmenschliche Dynamiken erleben und den Umgang damit erlernen.",
        },
        {
          title: "Organisationsentwicklung",
          text: "Veränderungsprozesse, die Strukturen ebenso berücksichtigen wie die Menschen darin.",
        },
      ],
    },
    aboutTeaser: {
      label: "Über David",
      title: "Der Mensch hinter der Arbeit",
      text: "Ich bin fasziniert von psychischen Dynamiken in und zwischen Menschen. Für den Moment, in dem Menschen ihre Masken fallen lassen und dadurch Verbindung zueinander und zu sich selbst entsteht, mache ich meinen Job.",
      cta: "Mehr über David",
      linkedin: "Auf LinkedIn vernetzen",
    },
    contact: {
      label: "Kontakt",
      title: "Lassen Sie uns sprechen.",
      text: "Sie möchten etwas verändern – in Ihrer Führung, Ihrem Team oder Ihrer Organisation? Ich freue mich auf Ihre Nachricht.",
      emailLabel: "E-Mail",
      phoneLabel: "Telefon",
      linkedinLabel: "LinkedIn",
      linkedinCta: "Vernetzen wir uns",
      location: "4040 Linz, Österreich",
      form: {
        name: "Ihr Name",
        email: "Ihre E-Mail",
        organization: "Organisation (optional)",
        message: "Worum geht es?",
        submit: "Nachricht senden",
        sending: "Wird gesendet …",
        success: "Danke für Ihre Nachricht. Ich melde mich persönlich bei Ihnen.",
        error: "Etwas hat nicht funktioniert. Bitte schreiben Sie direkt an david@davidfrank.at.",
        privacyPrefix: "Mit dem Absenden werden Ihre Angaben zur Bearbeitung Ihrer Anfrage verarbeitet. Weitere Informationen finden Sie in der",
        privacyLink: "Datenschutzerklärung",
      },
    },
    footer: {
      tagline: "Leadership und Team Performance durch psychologische Tiefe.",
      nav: "Navigation",
      contact: "Kontakt",
      rights: "Alle Rechte vorbehalten.",
      impressum: "Impressum",
      datenschutz: "Datenschutz",
      analytics: "Cookie-Einstellungen",
    },
    legal: {
      impressum: {
        label: "Rechtliches",
        title: "Impressum",
        updated: "Angaben gemäß § 5 ECG und § 24 MedienG",
        sections: [
          {
            h: "Medieninhaber und Betreiber dieser Website",
            p: "Ing. David Frank, MSc.\nFerihumerstraße 46, Tür 48\n4040 Linz\nÖsterreich\nTelefon: +43 681 81964809\nE-Mail: david@davidfrank.at\nWebsite: https://davidfrank.at",
          },
          {
            h: "Unternehmensgegenstand",
            p: "Coaching, Beratung und Training in den Bereichen Leadership, Team- und Organisationsentwicklung.",
          },
          {
            h: "Mitgliedschaft",
            p: "Mitglied der Wirtschaftskammer Oberösterreich.",
          },
          {
            h: "Aufsichtsbehörde / Gewerbebehörde",
            p: "Magistrat der Landeshauptstadt Linz",
          },
          {
            h: "Anwendbare Rechtsvorschriften",
            p: "Gewerbeordnung 1994 (GewO)\nhttps://www.ris.bka.gv.at",
          },
          {
            h: "Haftung für Inhalte",
            p: "Die Inhalte dieser Website werden mit größtmöglicher Sorgfalt erstellt. Für die Richtigkeit, Vollständigkeit und Aktualität der Inhalte wird jedoch keine Gewähr übernommen.",
          },
          {
            h: "Haftung für Links",
            p: "Diese Website enthält Links zu externen Websites Dritter. Auf deren Inhalte haben wir keinen Einfluss und übernehmen daher keine Gewähr. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber verantwortlich.",
          },
          {
            h: "Urheberrecht",
            p: "Die Inhalte und Werke auf dieser Website unterliegen dem Urheberrecht. Jede Verwendung, Vervielfältigung oder Verbreitung außerhalb der Grenzen des Urheberrechts bedarf der vorherigen schriftlichen Zustimmung von Ing. David Frank, MSc.",
          },
        ],
      },
      datenschutz: {
        label: "Rechtliches",
        title: "Datenschutzerklärung",
        updated: "Stand: 1. September 2026",
        sections: [
          {
            h: "1. Verantwortlicher",
            p: "Ing. David Frank, MSc.\nFerihumerstraße 46, Tür 48\n4040 Linz\nÖsterreich\nE-Mail: david@davidfrank.at\nTelefon: +43 681 81964809\nWebsite: https://davidfrank.at",
          },
          {
            h: "2. Allgemeines",
            p: "Der Schutz Ihrer persönlichen Daten ist uns wichtig. Wir verarbeiten personenbezogene Daten ausschließlich im Rahmen der geltenden datenschutzrechtlichen Bestimmungen, insbesondere der Datenschutz-Grundverordnung (DSGVO), des österreichischen Datenschutzgesetzes (DSG) und des Telekommunikationsgesetzes 2021 (TKG 2021).",
          },
          {
            h: "3. Besuch der Website und Hosting",
            p: "Beim Aufruf dieser Website werden durch den technischen Betrieb Informationen verarbeitet, die Ihr Browser automatisch übermittelt. Dazu können insbesondere IP-Adresse, Datum und Uhrzeit des Zugriffs, aufgerufene Seiten, Browsertyp, Betriebssystem, Referrer-URL und technische Informationen zum verwendeten Endgerät gehören.\nDie Verarbeitung erfolgt zur technischen Bereitstellung, Sicherheit und Stabilität der Website sowie zur Abwehr missbräuchlicher Zugriffe. Rechtsgrundlage ist unser berechtigtes Interesse gemäß Art. 6 Abs. 1 lit. f DSGVO.\nFür das Hosting und den technischen Betrieb der Website setzen wir externe technische Dienstleister ein. Diese verarbeiten Daten nur, soweit dies zur Bereitstellung und sicheren Nutzung der Website erforderlich ist.",
          },
          {
            h: "4. Cookies und Einwilligungsverwaltung",
            p: "Unsere Website verwendet technisch notwendige Technologien, insbesondere zur Speicherung Ihrer Cookie-Auswahl. Darüber hinaus setzen wir Analyse-Cookies ausschließlich ein, wenn Sie hierzu über das Cookie-Banner eingewilligt haben.\nSie können Ihre Einwilligung jederzeit mit Wirkung für die Zukunft über die Cookie-Einstellungen im Footer dieser Website ändern oder widerrufen.",
          },
          {
            h: "5. Webanalyse",
            p: "Nach Ihrer Einwilligung verwenden wir Google Analytics 4, einen Webanalysedienst der Google Ireland Limited, Gordon House, Barrow Street, Dublin 4, Irland.\nGoogle Analytics hilft uns zu verstehen, wie Besucherinnen und Besucher unsere Website nutzen. Dadurch können wir Inhalte, Struktur und Benutzerfreundlichkeit verbessern.\nDabei können insbesondere aufgerufene Seiten, Interaktionen mit der Website, Datum und Uhrzeit des Besuchs, Dauer und Häufigkeit des Besuchs, Geräte- und Browserinformationen, ungefähre geografische Herkunft sowie die Herkunft des Websitebesuchs verarbeitet werden.\nFür Zugriffe aus der EU, der Schweiz und dem Vereinigten Königreich werden in Google Analytics keine einzelnen IP-Adressen protokolliert oder gespeichert.\nDie Datenverarbeitung erfolgt ausschließlich auf Grundlage Ihrer Einwilligung gemäß § 165 Abs. 3 TKG 2021 und Art. 6 Abs. 1 lit. a DSGVO. Die Daten werden in Google Analytics für 14 Monate gespeichert und anschließend gelöscht bzw. anonymisiert.\nWeitere Informationen finden Sie in der Datenschutzerklärung von Google:\nhttps://policies.google.com/privacy",
          },
          {
            h: "6. Kontaktaufnahme",
            p: "Wenn Sie uns über das Kontaktformular, per E-Mail oder telefonisch kontaktieren, verarbeiten wir die von Ihnen übermittelten Daten. Dies können insbesondere Name, E-Mail-Adresse, Telefonnummer, Inhalt Ihrer Nachricht und sonstige freiwillig übermittelte Informationen sein.\nDie Verarbeitung erfolgt zur Bearbeitung Ihrer Anfrage und für mögliche Anschlussfragen. Rechtsgrundlage ist Art. 6 Abs. 1 lit. b DSGVO, soweit Ihre Anfrage auf den Abschluss oder die Durchführung eines Vertrags gerichtet ist. In allen anderen Fällen erfolgt die Verarbeitung auf Grundlage unseres berechtigten Interesses gemäß Art. 6 Abs. 1 lit. f DSGVO.\nDie über das Kontaktformular übermittelten Daten werden an unsere E-Mail-Adresse weitergeleitet und über Gmail verarbeitet. Dabei kann Google LLC, 1600 Amphitheatre Parkway, Mountain View, CA 94043, USA, Empfänger der Daten sein.\nWir speichern Anfragen grundsätzlich für sechs Monate ab Abschluss der Bearbeitung. Kommt es zu einem Vertragsverhältnis, bewahren wir die dafür erforderlichen Daten im Rahmen der gesetzlichen Aufbewahrungspflichten auf.",
          },
          {
            h: "7. Empfänger und Datenübermittlung in Drittländer",
            p: "Wir setzen technische Dienstleister ein, soweit dies für den Betrieb der Website und die Bearbeitung von Anfragen erforderlich ist. Dazu zählen insbesondere Hosting- und IT-Dienstleister, Google Ireland Limited für die Webanalyse sowie Google LLC im Zusammenhang mit Gmail.\nBei der Nutzung einzelner Dienste kann eine Verarbeitung personenbezogener Daten außerhalb des Europäischen Wirtschaftsraums stattfinden, insbesondere in den USA. Soweit dies der Fall ist, erfolgt die Übermittlung auf Grundlage eines Angemessenheitsbeschlusses der Europäischen Kommission oder geeigneter Garantien wie Standardvertragsklauseln gemäß Art. 46 DSGVO.",
          },
          {
            h: "8. Ihre Rechte",
            p: "Ihnen stehen insbesondere die Rechte auf Auskunft, Berichtigung, Löschung, Einschränkung der Verarbeitung, Datenübertragbarkeit, Widerspruch sowie Widerruf einer erteilten Einwilligung mit Wirkung für die Zukunft zu.\nZur Ausübung Ihrer Rechte wenden Sie sich bitte an:\ndavid@davidfrank.at\nSie haben außerdem das Recht, sich bei der österreichischen Datenschutzbehörde zu beschweren:\nÖsterreichische Datenschutzbehörde\nBarichgasse 40–42\n1030 Wien\nhttps://www.dsb.gv.at",
          },
          {
            h: "9. Automatisierte Entscheidungen",
            p: "Eine automatisierte Entscheidungsfindung einschließlich Profiling im Sinne des Art. 22 DSGVO findet nicht statt.",
          },
          {
            h: "10. Aktualisierung dieser Datenschutzerklärung",
            p: "Wir behalten uns vor, diese Datenschutzerklärung anzupassen, wenn sich unsere Website, die eingesetzten Dienste oder die rechtlichen Rahmenbedingungen ändern. Es gilt jeweils die auf dieser Website veröffentlichte aktuelle Fassung.",
          },
        ],
      },
    },
    pages: {
      leadership: {
        label: "Leadership-Entwicklung",
        title: "Menschliche Dynamiken verstehen lernen",
        sub: "Leadership ist mehr als Managementtechnik. Es beginnt in Dir.",
        quote1: "Leadership doesn't require a title.",
        quote2: "It's a decision.",
        whyTitle: "Wo Führung herausfordernd wird",
        whyText: "Viele Führungsherausforderungen sind keine Wissensprobleme. Sie kommen in sozialen Themen zum Vorschein. Wie nehme ich Menschen mit? Was tun bei Spannung im Team? Wie gelingt Augenhöhe und Leistung? Wie gehe ich mit Misstrauen um? Manchmal sind es dann unsere eigenen blinden Flecken, Glaubenssätze und inneren Widersprüche, welche die Situation hervorrufen. Doch wer diese Dynamiken in sich erkennt, kann sie sowohl bei sich als auch zwischen Menschen verstehen und gestalten.",
        methodLabel: "Methodisches Vorgehen",
        methodTitle: "Psychologie spürbar machen",
        methodInput: "Input",
        methodInputText: "Wissen aus Psychologie, Organisationsentwicklung, Gruppendynamik und Lean Management – leicht verständlich aufbereitet und in den Alltag transferierbar.",
        methodExplore: "Erforschen",
        methodExploreText: "Gruppendynamik spüren, Selbsterfahrung, Rollenspiele, Komfortzone verlassen, Planspiele, 360°-Feedback, Aufstellungen, Peergroup-Coaching, Gruppen- und Selbstreflexion.",
        fieldsLabel: "Themenfelder",
        fieldsTitle: "Kompetenz fürs Menschliche",
        fields: [
          {
            title: "Selbst & Menschen führen",
            groups: [
              {
                sub: "Selbstführung",
                items: ["Selbst- & Fremdwahrnehmung", "Selbstreflexion & Blinde Flecken", "Glaubenssätze & Emotionen", "Haltung als Entscheidung", "Resilienz, Zeitmanagement"],
              },
              {
                sub: "Führungsstil & Situatives Führen",
                items: ["Eigener Führungsstil", "Situatives Führen", "Leadership & Management", "Sandwich-Position & Erwartungen klären", "Gesprächsführung"],
              },
            ],
          },
          {
            title: "Team Performance",
            groups: [
              {
                sub: "Team Wissen & Gruppendynamik",
                items: ["Teamphasen & Machtdynamiken", "Arten von Teams", "Metaebene in Teams einführen", "Delegieren & Verantwortung"],
              },
              {
                sub: "Performance & Psychologische Sicherheit",
                items: ["Vision, Mission, Strategie", "Wertschöpfung", "Vertrauen fördern", "Direktheit vs. Empathie", "Umgang mit Konflikten"],
              },
            ],
          },
          {
            title: "Culture & Change",
            groups: [
              {
                sub: "Kultur im Unternehmen beeinflussen",
                items: ["Vorder- & Hinterbühne der Kultur", "Soziale Dynamiken", "Wechselwirkungen von Verhaltensweisen", "Organisationsmodelle"],
              },
              {
                sub: "Change Management",
                items: ["Grundlagen der System Theorie", "Change Architektur", "Ebenen der Organisationsentwicklung", "Motivation fördern", "Mitarbeitende involvieren"],
              },
            ],
          },
        ],
        ctaTitle: "Führung ist eine Entscheidung.",
        ctaText: "Wenn Sie Ihre Führungstiefe weiterentwickeln möchten – lassen Sie uns sprechen.",
      },
      teams: {
        label: "Team-Entwicklung",
        title: "Performance durch psychologische Sicherheit",
        sub: "Teams werden nicht durch Harmonie stark, sondern durch die Fähigkeit, offen und direkt miteinander zu sein – ohne einander zu verletzen.",
        quote1: "Was liegt den Menschen im Team wirklich am Herzen?",
        quote2: "",
        quoteSide: "Dort wo Masken fallen gelassen werden, kann Verbindung zueinander entstehen. Meist liegt dort die Energie im Team begraben. In der Teamentwicklung öffne ich sichere Räume, um diesen Prozess zu begleiten.",
        matrixLabel: "Fokus in der Team-Entwicklung",
        matrixTitle: "Zwischen Kuschelgruppe und Brutalo-Gang",
        matrixIntro: "Jedes Team bewegt sich im Spannungsfeld von Direktheit und Akzeptanz. Die entscheidende Frage lautet nicht, ob Spannungen auftreten – sondern wie ein Team mit ihnen umgeht. (Angelehnt an Rieckmann, 2007)",
        axisX: "Direktheit · Offenheit",
        axisY: "Akzeptanz · Empathie",
        quadrants: [
          { key: "kuschel", title: "Kuschelgruppe", text: "Außen heile Welt, jedoch kein Feedback, keine Entwicklung, innerer Frust." },
          { key: "brutalo", title: "Brutalo-Gang", text: "Sehr direkt, sieht den eigenen Anteil nicht, gegenseitig verletzend, übervorsichtig." },
          { key: "bezug", title: "Kolleg:innen ohne Bezug", text: "Weder echte Auseinandersetzung noch echte Verbindung." },
          { key: "performance", title: "Performance Team", text: "Gegenseitiges Vertrauen, gemeinsames Lernen, offenes Feedback und Empathie." },
        ],
        change: "Veränderung kann innerhalb eines Workshops spürbar werden, wenn der passende Rahmen gesetzt wird.",
        topicsTitle: "Woran wir arbeiten",
        topics: ["Vertrauen fördern", "Metaebene im Team", "Ansprechen was am Herzen liegt", "Umgang mit Spannungen", "Wechselwirkungen & Muster", "Teamausrichtung, Struktur & Erwartungen"],
        ctaTitle: "Was wäre möglich, wenn Ihr Team anspricht, was wirklich los ist?",
        ctaText: "Ich schaffe Räume, in denen Teams ihre Dynamiken direkt erkennen und verändern können.",
      },
      strategie: {
        label: "Dynamische Strategie",
        title: "Auf instabilen Zeiten surfen lernen",
        sub: "Klassische Strategie geht implizit davon aus, dass die Zukunft planbar ist. In meinem Strategieprozess machen wir uns das Unplanbare zu Nutze.",
        introTitle: "Die Zukunft lässt sich noch immer nicht vorhersagen.",
        introText: "Doch wenigstens das ist sicher. Deswegen denke ich, dass wir Strategie grundlegend neu denken müssen. Dafür habe ich einen dynamischen Strategieprozess entwickelt und mehrfach eingeführt – um dem Unvorhersagbaren dieser Zeit nicht ausgeliefert zu sein, sondern es erfolgreich zu nutzen.",
        charsLabel: "Der Prozess",
        charsTitle: "Was den dynamischen Strategieprozess auszeichnet",
        chars: [
          { title: "Der Markt entscheidet", text: "Strategische Inhalte folgen dem Marktresponse – nicht das Unternehmen entscheidet über die Strategie, sondern der Kunde." },
          { title: "Das Unvorhergesehene ist Teil der Strategie", text: "Kein Verwerfen oder Neugestalten der Strategie notwendig." },
          { title: "Strategie ist immer in Umsetzung", text: "Keine lange Planungsphase notwendig." },
          { title: "Entscheidungen werden sofort getroffen", text: "Nicht erst im nächsten Strategieprozess." },
          { title: "Transparent und konkret", text: "Jede Person weiß zu jeder Zeit, woran gerade gearbeitet wird." },
          { title: "Alle wirken mit", text: "Mitarbeitende gestalten die Strategie aktiv mit – Wissen und Erfahrungen aller werden gebraucht." },
        ],
        ctaTitle: "Bereit, die Welle zu surfen?",
        ctaText: "Wenn Ihre Strategie mit der Realität Schritt halten soll – lassen Sie uns sprechen.",
      },
      organisation: {
        label: "Organisations- & Kulturentwicklung",
        title: "Menschen bei Veränderungen mitnehmen",
        sub: "Veränderung ist nicht nur ein strukturelles Thema. Sie ist vor allem ein sozialer und persönlicher Prozess.",
        journeyLabel: "Vom IST zum SOLL",
        journeyTitle: "Räume für Veränderung öffnen",
        journeyText: "Neue Strukturen und Prozesse sind schnell skizziert und umgestellt – wären da nicht auch noch die Menschen im Unternehmen. Irgendeiner hat doch immer was dagegen. Wenn es in der Organisation bei Veränderungen zu „menscheln“ beginnt, kann aktives Change-Management helfen.",
        ist: "IST",
        soll: "SOLL",
        dims: ["Strategie", "Kultur", "Struktur"],
        expLabel: "Erfahrung",
        expTitle: "Veränderung in großem Maßstab",
        expText: "Ich habe langjährige Erfahrung im Auf- und Umsetzen von Veränderungsprojekten – von strukturellen Veränderungen, Lean-Management-Einführung, Selbstorganisation und Visions- & Strategie-Erarbeitung bis hin zu großen, globalen Kulturentwicklungsprojekten mit 10.000 Betroffenen.",
        expBig: "10 Jahre",
        expBigText: "Beratungserfahrung in globalen Unternehmen",
        expCta: "Egal, was Sie vorhaben: Ich unterstütze Sie dabei, Ihre Mitarbeitenden auf der Reise von IST zu SOLL mitzunehmen und die Veränderung nachhaltig zu verankern.",
        workTitle: "Woran wir arbeiten können",
        workItems: [
          "Vision, Mission, Werte",
          "Strategieprozess & Umsetzungsbegleitung",
          "KI Prozesse, Wertstrom, Datenstrom",
          "Lean- & Performance Kultur",
          "Agilität & Selbstorganisation",
          "Restrukturierung & Neuausrichtung",
        ],
        ctaTitle: "Veränderung beginnt bei den Menschen.",
        ctaText: "Lassen Sie uns über Ihre Organisation sprechen.",
      },
      about: {
        label: "Über mich",
        title: "David Frank",
        heroSub: "Im Unglück Mut – im Glück Demut.",
        motto1: "Im Unglück Mut –",
        motto2: "im Glück Demut.",
        name: "Ing. David Frank, MSc.",
        role: "Coaching · Training · Organisationsentwicklung",
        storyTitle: "Vom Ingenieur zur Psychologie der Zusammenarbeit",
        story: [
          "Ich bin fasziniert von psychischen Dynamiken in und zwischen Menschen. Für den Moment, in dem Menschen ihre Masken fallen lassen und dadurch Verbindung zueinander und zu sich selbst entsteht, mache ich meinen Job.",
          "Deswegen habe ich nach ein paar Jahren als Ingenieur den Weg in die interne Beratung als Organisationsentwickler und Führungskräftetrainer eingeschlagen. In unterschiedlichen global agierenden Unternehmen durfte ich mich – von Lean Management bis Strategieentwicklung – mit der vollen Bandbreite an Managementzugängen beschäftigen und verantwortete Kulturentwicklungsprogramme, die 10.000 Mitarbeitende involvierten.",
          "In meinem Studium der Organisationsentwicklung und zahlreichen Weiterbildungen lernte ich über zwischenmenschliche Dynamiken und menschliche Entwicklung. Aktuell ergänze ich noch mehr psychologische Tiefe durch mein Studium der Psychotherapie.",
        ],
        qualLabel: "Hintergrund",
        qualTitle: "Aus- & Weiterbildung",
        quals: [
          "Organizational & People Development & Systemic Coaching — Sigmund Freud Privatuniversität Wien, Master of Science",
          "In Ausbildung zum Psychotherapeuten — Donau Universität Krems",
          "Hypnosystemisches Coaching bei Gunther Schmidt",
          "Gruppendynamik-Weiterbildung (ARGE)",
          "Ego-Development-Zertifizierung — Thomas Binder",
          "Holacracy Practitioner & Agile Training — dwarfs and Giants",
          "Radical Honesty Kommunikationstrainings",
          "Lean Management & Design Thinking",
          "Achtsamkeitstrainings, u. a. Stille-Retreats",
        ],
        expLabel: "Erfahrung",
        expTitle: "Woher ich komme",
        expItems: [
          "Leadership Development & Organizational Development — u. a. doka GmbH, umdasch shopfitting GmbH, KEBA AG, ENGEL GmbH, bellaflora GmbH",
          "Programmleitung Lean Culture — 10.000 Mitarbeitende",
          "Gewerbe der Unternehmensberatung einschließlich Unternehmensorganisation",
        ],
        ctaTitle: "Lernen wir uns kennen.",
        ctaText: "Ich freue mich auf das Gespräch mit Ihnen.",
      },
    },
  },
  en: {
    nav: {
      leadership: "Leadership",
      teams: "Team",
      organisation: "Organisation",
      strategie: "Strategy",
      about: "About",
      contact: "Contact",
      cta: "Get in touch",
      menu: "Menu",
      close: "Close",
    },
    consent: {
      text: "We use analytics cookies to better understand how this website is used. This allows us to continuously improve it.",
      privacy: "Privacy policy",
      settings: "Settings",
      accept: "Accept",
      close: "Close",
      settingsTitle: "Cookie settings",
      necessary: "Strictly necessary",
      alwaysActive: "Always active",
      analytics: "Analytics",
      save: "Save selection",
    },
    hero: {
      eyebrow: "Coaching · Training · Organizational Development",
      line1: "Leadership &",
      line2: "Team Performance",
      accent: "Effective through psychological depth.",
      sub: "When leadership, collaboration and change become truly challenging, the real issues rarely lie on the surface.",
      ctaPrimary: "Get in touch",
      ctaSecondary: "Learn more",
      scroll: "Scroll",
    },
    human: {
      label: "Starting point",
      line1: "Organisations change.",
      line2: "People remain human.",
      body: "With convictions and emotions. With strengths and contradictions. Perfectly imperfect.",
      question: "What would be possible if you could use this energy for your vision?",
      imgAlt: "David Frank — portrait",
    },
    manifesto: {
      label: "What shapes my work",
      chapters: [
        {
          num: "01",
          title: "Attitude matters",
          text: "Attitude, behaviour and culture make the decisive difference when it comes to performance. My focus therefore lies on changing patterns and dynamics within and between people.",
        },
        {
          num: "02",
          title: "Uniting worlds",
          text: "I bring together perspectives from leadership development, lean management, organizational development, change management, group dynamics and psychology — consciously combining them into effective development processes.",
        },
        {
          num: "03",
          title: "Making development tangible",
          text: "In trainings, workshops and projects I foster the conscious inner experience of new situations and create mirrors for self-reflection. This produces new reference experiences with lasting effect — in certain settings, change becomes tangible in the present moment.",
        },
      ],
    },
    focus: {
      label: "Fields of work",
      title: "What we can work on together",
      items: [
        {
          to: "/leadership",
          img: "/images/svc-leadership.jpg",
          alt: "Roped party of mountaineers in a vast, snow-covered mountain landscape",
          title: "Leadership Development",
          short: "Leadership",
          sub: "Learning to understand human dynamics",
        },
        {
          to: "/team",
          img: "/images/svc-team.jpg",
          alt: "Two athletes standing together in a narrow boat on calm water — black and white photograph",
          title: "Team Development",
          short: "Team",
          sub: "Performance through psychological safety",
        },
        {
          to: "/strategie",
          img: "/images/svc-strategy.jpg",
          alt: "A breaking wave in deep blue",
          title: "Dynamic Strategy",
          short: "Strategy",
          sub: "Learning to surf unstable times",
        },
        {
          to: "/organisation",
          img: "/images/svc-organisation.jpg",
          alt: "Crowd on a zebra crossing seen from above — black and white photograph",
          title: "Organisation & Culture",
          short: "Organisation",
          sub: "Bringing people along through change",
        },
      ],
      more: "Explore",
    },
    statement: {
      line1: "“Psychological depth",
      line2: "meets business performance.”",
    },
    cases: {
      label: "Use cases",
      title: "Perhaps this sounds familiar.",
      cta: "Explore the field",
      items: [
        {
          title: "Being a manager AND a leader",
          text: "Professional expertise got me here. But how do I lead when expectations diverge, tensions arise or people simply don't come along?",
          field: 0,
        },
        {
          title: "The unpredictable takes over the strategy",
          text: "We do have a plan — but it only holds until the next news headline. In times like these it is hard to find anything to hold on to. What if the unpredictable became part of our strategy?",
          field: 2,
        },
        {
          title: "No drive left in the team",
          text: "Everything is running, in principle. Yet somehow the energy is missing. Still, nobody says what is really going on. How do we get back into conversation?",
          field: 1,
        },
        {
          title: "Change — but nobody joins in",
          text: "Lean. Agile. AI. One change chases the next. Structures are adjusted quickly — but how do we get people to truly come along?",
          field: 3,
        },
      ],
    },
    formats: {
      label: "Formats",
      title: "Three ways of creating development",
      items: [
        {
          title: "Coaching",
          text: "Individual reflection, perspective and development — in a protected setting.",
        },
        {
          title: "Training",
          text: "Experience human and interpersonal dynamics and learn how to work with them.",
        },
        {
          title: "Organizational Development",
          text: "Change processes that consider structures as much as the people within them.",
        },
      ],
    },
    aboutTeaser: {
      label: "About David",
      title: "The person behind the work",
      text: "I am fascinated by the psychological dynamics within and between people. I do this work for the moment when people let their masks drop — and genuine connection with each other and with themselves emerges.",
      cta: "More about David",
      linkedin: "Connect on LinkedIn",
    },
    contact: {
      label: "Contact",
      title: "Let's talk.",
      text: "Do you want to change something — in your leadership, your team or your organisation? I look forward to hearing from you.",
      emailLabel: "Email",
      phoneLabel: "Phone",
      linkedinLabel: "LinkedIn",
      linkedinCta: "Let's connect",
      location: "4040 Linz, Austria",
      form: {
        name: "Your name",
        email: "Your email",
        organization: "Organisation (optional)",
        message: "What is it about?",
        submit: "Send message",
        sending: "Sending …",
        success: "Thank you for your message. I will get back to you personally.",
        error: "Something went wrong. Please write directly to david@davidfrank.at.",
        privacyPrefix: "By submitting, your details will be processed to handle your enquiry. Further information is available in the",
        privacyLink: "privacy policy",
      },
    },
    footer: {
      tagline: "Leadership and team performance through psychological depth.",
      nav: "Navigation",
      contact: "Contact",
      rights: "All rights reserved.",
      impressum: "Imprint",
      datenschutz: "Privacy",
      analytics: "Cookie settings",
    },
    legal: {
      impressum: {
        label: "Legal",
        title: "Imprint",
        updated: "Information pursuant to § 5 ECG and § 24 MedienG",
        sections: [
          {
            h: "Media owner and operator of this website",
            p: "Ing. David Frank, MSc.\nFerihumerstraße 46, Tür 48\n4040 Linz\nAustria\nPhone: +43 681 81964809\nEmail: david@davidfrank.at\nWebsite: https://davidfrank.at",
          },
          {
            h: "Business purpose",
            p: "Coaching, consulting and training in the areas of leadership, team and organisational development.",
          },
          {
            h: "Membership",
            p: "Member of the Upper Austrian Chamber of Commerce.",
          },
          {
            h: "Supervisory authority / trade authority",
            p: "Magistrate of the City of Linz",
          },
          {
            h: "Applicable legal provisions",
            p: "Austrian Trade Regulation Act 1994 (GewO)\nhttps://www.ris.bka.gv.at",
          },
          {
            h: "Liability for content",
            p: "The content of this website is created with the greatest possible care. However, no guarantee is given for the accuracy, completeness or timeliness of the content.",
          },
          {
            h: "Liability for links",
            p: "This website contains links to external third-party websites. We have no influence on their content and therefore accept no liability. The respective provider or operator is always responsible for the content of the linked pages.",
          },
          {
            h: "Copyright",
            p: "The content and works on this website are subject to copyright. Any use, reproduction or distribution outside the limits of copyright law requires the prior written consent of Ing. David Frank, MSc.",
          },
        ],
      },
      datenschutz: {
        label: "Legal",
        title: "Privacy Policy",
        updated: "As of: September 1, 2026",
        sections: [
          {
            h: "1. Controller",
            p: "Ing. David Frank, MSc.\nFerihumerstraße 46, Tür 48\n4040 Linz\nAustria\nEmail: david@davidfrank.at\nPhone: +43 681 81964809\nWebsite: https://davidfrank.at",
          },
          {
            h: "2. General information",
            p: "Protecting your personal data is important to us. We process personal data exclusively within the framework of the applicable data protection regulations, in particular the General Data Protection Regulation (GDPR), the Austrian Data Protection Act (DSG) and the Austrian Telecommunications Act 2021 (TKG 2021).",
          },
          {
            h: "3. Website visits and hosting",
            p: "When this website is accessed, information automatically transmitted by your browser is processed for technical operation. This may include IP address, date and time of access, pages visited, browser type, operating system, referrer URL and technical information about the device used.\nProcessing takes place for the technical provision, security and stability of the website and to defend against abusive access. The legal basis is our legitimate interest pursuant to Art. 6(1)(f) GDPR.\nWe use external technical service providers for hosting and the technical operation of the website. They process data only to the extent required to provide and securely operate the website.",
          },
          {
            h: "4. Cookies and consent management",
            p: "Our website uses technically necessary technologies, in particular to store your cookie selection. In addition, we use analytics cookies only if you have consented to them via the cookie banner.\nYou can change or withdraw your consent at any time with effect for the future via the cookie settings in the footer of this website.",
          },
          {
            h: "5. Web analytics",
            p: "After your consent, we use Google Analytics 4, a web analytics service provided by Google Ireland Limited, Gordon House, Barrow Street, Dublin 4, Ireland.\nGoogle Analytics helps us understand how visitors use our website. This allows us to improve content, structure and usability.\nThis may include processing pages visited, interactions with the website, date and time of the visit, visit duration and frequency, device and browser information, approximate geographic origin and the source of the website visit.\nFor access from the EU, Switzerland and the United Kingdom, Google Analytics does not log or store individual IP addresses.\nData processing takes place exclusively on the basis of your consent pursuant to § 165(3) TKG 2021 and Art. 6(1)(a) GDPR. Data is stored in Google Analytics for 14 months and then deleted or anonymised.\nFurther information can be found in Google's privacy policy:\nhttps://policies.google.com/privacy",
          },
          {
            h: "6. Contact",
            p: "If you contact us via the contact form, by email or by phone, we process the data you provide. This may include your name, email address, phone number, the content of your message and other voluntarily submitted information.\nProcessing takes place to handle your enquiry and possible follow-up questions. The legal basis is Art. 6(1)(b) GDPR where your enquiry relates to concluding or performing a contract. In all other cases, processing is based on our legitimate interest pursuant to Art. 6(1)(f) GDPR.\nData submitted via the contact form is forwarded to our email address and processed via Gmail. Google LLC, 1600 Amphitheatre Parkway, Mountain View, CA 94043, USA, may be a recipient of the data.\nWe generally store enquiries for six months after processing has been completed. If a contractual relationship is established, we retain the required data in accordance with statutory retention obligations.",
          },
          {
            h: "7. Recipients and data transfers to third countries",
            p: "We use technical service providers where this is necessary for operating the website and handling enquiries. These include in particular hosting and IT service providers, Google Ireland Limited for web analytics and Google LLC in connection with Gmail.\nWhen individual services are used, personal data may be processed outside the European Economic Area, in particular in the USA. Where this is the case, the transfer takes place on the basis of an adequacy decision by the European Commission or appropriate safeguards such as standard contractual clauses pursuant to Art. 46 GDPR.",
          },
          {
            h: "8. Your rights",
            p: "You have in particular the rights of access, rectification, erasure, restriction of processing, data portability, objection and withdrawal of consent with effect for the future.\nTo exercise your rights, please contact:\ndavid@davidfrank.at\nYou also have the right to lodge a complaint with the Austrian Data Protection Authority:\nAustrian Data Protection Authority\nBarichgasse 40–42\n1030 Vienna\nhttps://www.dsb.gv.at",
          },
          {
            h: "9. Automated decisions",
            p: "No automated decision-making, including profiling within the meaning of Art. 22 GDPR, takes place.",
          },
          {
            h: "10. Updates to this privacy policy",
            p: "We reserve the right to update this privacy policy if our website, the services used or the legal framework changes. The current version published on this website applies in each case.",
          },
        ],
      },
    },
    pages: {
      leadership: {
        label: "Leadership Development",
        title: "Learning to understand human dynamics",
        sub: "Leadership is more than management technique. It begins within you.",
        quote1: "Leadership doesn't require a title.",
        quote2: "It's a decision.",
        whyTitle: "Where leadership becomes challenging",
        whyText: "Many leadership challenges are not knowledge problems. They surface in social topics. How do I bring people along? What to do about tension in the team? How do eye level and performance go together? How do I deal with mistrust? Sometimes it is our own blind spots, beliefs and inner contradictions that cause the situation. But those who recognise these dynamics within themselves can understand and shape them both within themselves and between people.",
        methodLabel: "Methodology",
        methodTitle: "Making psychology tangible",
        methodInput: "Input",
        methodInputText: "Knowledge from psychology, organizational development, group dynamics and lean management — made easy to understand and transferable into everyday work.",
        methodExplore: "Exploration",
        methodExploreText: "Sensing group dynamics, self-experience, role play, leaving the comfort zone, simulations, 360° feedback, constellations, peer-group coaching, group and self-reflection.",
        fieldsLabel: "Topics",
        fieldsTitle: "Competence for the human side",
        fields: [
          {
            title: "Leading yourself & others",
            groups: [
              {
                sub: "Self-leadership",
                items: ["Self- and external perception", "Self-reflection & blind spots", "Beliefs & emotions", "Attitude as a decision", "Resilience & time management"],
              },
              {
                sub: "Leadership style & situational leadership",
                items: ["Your own leadership style", "Situational leadership", "Leadership & management", "Sandwich position & clarifying expectations", "Conversation skills"],
              },
            ],
          },
          {
            title: "Team Performance",
            groups: [
              {
                sub: "Team knowledge & group dynamics",
                items: ["Team phases & power dynamics", "Types of teams", "Introducing a meta level in teams", "Delegating & responsibility"],
              },
              {
                sub: "Performance & psychological safety",
                items: ["Vision, mission, strategy", "Value creation", "Building trust", "Directness vs. empathy", "Dealing with conflict"],
              },
            ],
          },
          {
            title: "Culture & Change",
            groups: [
              {
                sub: "Influencing company culture",
                items: ["Front stage & back stage of culture", "Social dynamics", "Interplay of behaviours", "Organisational models"],
              },
              {
                sub: "Change management",
                items: ["Fundamentals of systems theory", "Change architecture", "Levels of organizational development", "Fostering motivation", "Involving employees"],
              },
            ],
          },
        ],
        ctaTitle: "Leadership is a decision.",
        ctaText: "If you want to deepen your leadership — let's talk.",
      },
      teams: {
        label: "Team Development",
        title: "Performance through psychological safety",
        sub: "Teams do not grow strong through harmony, but through the ability to be open and direct with each other — without hurting one another.",
        quote1: "What do the people in your team truly care about?",
        quote2: "",
        quoteSide: "Where masks are dropped, connection with one another can emerge. That is usually where the team's energy lies buried. In team development I open safe spaces to accompany this process.",
        matrixLabel: "Focus of team development",
        matrixTitle: "Between cuddle group and brutal gang",
        matrixIntro: "Every team moves within the field of tension between directness and acceptance. The decisive question is not whether tensions arise — but how a team deals with them. (Based on Rieckmann, 2007)",
        axisX: "Directness · Openness",
        axisY: "Acceptance · Empathy",
        quadrants: [
          { key: "kuschel", title: "Cuddle group", text: "All is well on the outside — yet no feedback, no development, inner frustration." },
          { key: "brutalo", title: "Brutal Gang", text: "Highly direct, blind to its own part, mutually hurtful, overly cautious." },
          { key: "bezug", title: "Colleagues without connection", text: "Neither real engagement nor real connection." },
          { key: "performance", title: "Performance Team", text: "Mutual trust, shared learning, open feedback and empathy." },
        ],
        change: "Change can become tangible within a single workshop — when the right frame is set.",
        topicsTitle: "What we work on",
        topics: ["Building trust", "Meta level in the team", "Speaking about what really matters", "Dealing with tension", "Interplay & patterns", "Team direction, structure & expectations"],
        ctaTitle: "What would be possible if your team spoke about what is really going on?",
        ctaText: "I create spaces in which teams can directly recognise and change their dynamics.",
      },
      strategie: {
        label: "Dynamic Strategy",
        title: "Learning to surf unstable times",
        sub: "Classical strategy implicitly assumes that the future can be planned. In my strategy process we put the unplannable to use.",
        introTitle: "The future still cannot be predicted.",
        introText: "But at least that much is certain. That is why I believe we need to fundamentally rethink strategy. For this I developed a dynamic strategy process and have introduced it several times — so that we are not at the mercy of the unpredictable, but can use it successfully.",
        charsLabel: "The process",
        charsTitle: "What characterises the dynamic strategy process",
        chars: [
          { title: "The market decides", text: "Strategic content follows the market response — it is not the company that decides on the strategy, but the customer." },
          { title: "The unforeseen is part of the strategy", text: "No need to discard or redesign the strategy." },
          { title: "Strategy is always in implementation", text: "No long planning phase required." },
          { title: "Decisions are made immediately", text: "Not in the next strategy cycle." },
          { title: "Transparent and concrete", text: "Everyone knows at all times what is being worked on." },
          { title: "Everyone contributes", text: "Employees actively shape the strategy — the knowledge and experience of all are needed." },
        ],
        ctaTitle: "Ready to surf the wave?",
        ctaText: "If your strategy should keep pace with reality — let's talk.",
      },
      organisation: {
        label: "Organizational & Culture Development",
        title: "Bringing people along through change",
        sub: "Change is not just a structural issue. Above all, it is a social and personal process.",
        journeyLabel: "From the as-is to the to-be",
        journeyTitle: "Opening spaces for change",
        journeyText: "New structures and processes are quickly sketched and implemented. If only change were that simple. But organisations are made of people — and someone will always have reservations. When change starts to get ‘human’, active change management can help.",
        ist: "AS-IS",
        soll: "TO-BE",
        dims: ["Strategy", "Culture", "Structure"],
        expLabel: "Experience",
        expTitle: "Change at scale",
        expText: "I have many years of experience setting up and implementing change projects — from structural change, lean management implementation, self-organisation and vision & strategy development to large, global culture development projects affecting 10,000 people.",
        expBig: "10 years",
        expBigText: "consulting experience in global companies",
        expCta: "Whatever you are planning: I will support you in bringing your people along on the journey from as-is to to-be — and anchoring the change sustainably.",
        workTitle: "What we can work on",
        workItems: [
          "Vision, mission, values",
          "Strategy process & implementation support",
          "AI processes, value stream, data flow",
          "Lean & performance culture",
          "Agility & self-organisation",
          "Restructuring & realignment",
        ],
        ctaTitle: "Change starts with people.",
        ctaText: "Let's talk about your organisation.",
      },
      about: {
        label: "About me",
        title: "David Frank",
        heroSub: "Courage in misfortune – humility in fortune.",
        motto1: "Courage in misfortune —",
        motto2: "humility in fortune.",
        name: "Ing. David Frank, MSc.",
        role: "Coaching · Training · Organizational Development",
        storyTitle: "From engineer to the psychology of collaboration",
        story: [
          "I am fascinated by the psychological dynamics within and between people. I do this work for the moment when people let their masks drop — and genuine connection with each other and with themselves emerges.",
          "That is why, after a few years as an engineer, I moved into internal consulting as an organizational developer and leadership trainer. In various globally operating companies I worked across the full range of management approaches — from lean management to strategy development — and was responsible for culture development programmes involving 10,000 employees.",
          "In my organizational development studies and numerous further trainings, I learned about interpersonal dynamics and human development. I am currently adding even more psychological depth through my psychotherapy studies.",
        ],
        qualLabel: "Background",
        qualTitle: "Education & training",
        quals: [
          "Organizational & People Development & Systemic Coaching — Sigmund Freud Private University Vienna, Master of Science",
          "Currently in psychotherapy training — Danube University Krems",
          "Hypnosystemic coaching with Gunther Schmidt",
          "Group dynamics training (ARGE)",
          "Ego-Development certification — Thomas Binder",
          "Holacracy Practitioner & Agile Training — dwarfs and giants",
          "Radical Honesty communication trainings",
          "Lean management & design thinking",
          "Mindfulness trainings, incl. silent retreats",
        ],
        expLabel: "Experience",
        expTitle: "Where I come from",
        expItems: [
          "Leadership Development & Organizational Development — incl. doka GmbH, umdasch shopfitting GmbH, KEBA AG, ENGEL GmbH, bellaflora GmbH",
          "Programme lead Lean Culture — 10,000 employees",
          "Licensed trade in business consulting incl. business organisation",
        ],
        ctaTitle: "Let's get to know each other.",
        ctaText: "I look forward to our conversation.",
      },
    },
  },
};
